module.exports = __webpack_public_path__ + "static/media/15.Cube-Moulds.f094f6cf.webp";